import { Component, Input, OnInit } from '@angular/core';
import { environment } from '../../../../../src/environments/environment';

@Component({
  selector: 'app-ver-recetas',
  templateUrl: './ver-recetas.component.html',
  styleUrls: ['./ver-recetas.component.scss']
})
export class VerRecetasComponent implements OnInit {

  @Input() rec: any;
  urlbucket = environment.urlbucket;
  urlcloudfront = environment.urlcloudfront;

  constructor() { }

  ngOnInit(): void {
    /** */
  }

  goToRececta(): void {
    /** */
  }


}
